import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="8554" id="chamada-para-ação" ref={sectionRef} className="relative w-full py-32 overflow-hidden bg-background text-foreground bg-gradient-to-br from-[#FF006E] to-[#1A1A1A] flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(45deg,rgba(255,255,255,0.05)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.05)_50%,rgba(255,255,255,0.05)_75%,transparent_75%,transparent)] bg-[length:40px_40px] opacity-60" />

      <div className="container relative z-10 px-4 mx-auto text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-white mb-12 drop-shadow-2xl">
            Pronto para escalar seu varejo?
          </h2>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            {}
            <Button asChild size="lg" className="bg-transparent text-white hover:bg-white/10 border-2 border-white h-14 px-10 text-lg font-semibold shadow-2xl transition-transform hover:scale-105">
              <Link to="/ContactsPage">
                Receber Contato Comercial
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>

            {}
            <Button asChild variant="ghost" size="lg" className="bg-[#25D366] text-white hover:bg-[#25D366]/90 h-14 px-10 text-lg font-medium transition-colors border-none">
              <Link to="https://api.whatsapp.com/send?phone=5527992826653&text=Bem%20vindo%20a%20Franquia%20Linx%20Vila%20Velha.">
                Falar WhatsApp
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}